<div class="session-overlay-container">
    <div class="toaster-wrapper mat-elevation-z2">
        <em class="material-icons close-icon" (click)="close()">close </em>
        <div class="content-wrapper">
            <em class="material-icons info-icon">info</em>
            <div class="toaster-content" [innerHtml]="translate('label.gb.bfrtimeot')">
              
            </div>
        </div>
        
        <button mat-raised-button class="btn-styl" color="primary"  (click)="btnClick($event)"> Extend</button>
    </div>
</div>